import { IMAGE_FORMATS } from "@/constants";

export function buildImageInput() {
    const input = document.createElement("input");
    input.type = "file";
    input.style = "display: none;";
    input.accept = `${IMAGE_FORMATS.join(",")}`;

    document.body.append(input);

    return input;
}
